import { render, staticRenderFns } from "./InstrucaoMedicaoInventario.vue?vue&type=template&id=e933b008&scoped=true"
import script from "./InstrucaoMedicaoInventario.vue?vue&type=script&setup=true&lang=js"
export * from "./InstrucaoMedicaoInventario.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstrucaoMedicaoInventario.vue?vue&type=style&index=0&id=e933b008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e933b008",
  null
  
)

export default component.exports